import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export function SearchInput({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative flex-1 min-w-[200px] max-w-sm">
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <Input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="rounded-xl pl-9 pr-9 bg-white"
      />
      {value && (
        <button
          data-testid={`${testId}-clear`}
          onClick={() => onChange("")}
          aria-label="Effacer"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-navy"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

export function PaginationBar({ total, page, pageSize, totalPages, onPage, onSize, loading, testPrefix = "" }) {
  return (
    <div className="flex flex-wrap gap-3 items-center justify-between mt-5 text-sm">
      <div className="flex items-center gap-2">
        <span className="text-muted-foreground" data-testid={`${testPrefix}pagination-total`}>
          {total} résultat{total > 1 ? "s" : ""}
        </span>
        <Select value={String(pageSize)} onValueChange={(v) => onSize(Number(v))}>
          <SelectTrigger data-testid={`${testPrefix}pagination-size`} className="w-28 h-8 rounded-lg bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {[20, 50, 100].map((n) => (
              <SelectItem key={n} value={String(n)}>{n} / page</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <Button
          data-testid={`${testPrefix}pagination-prev`}
          size="sm" variant="outline"
          disabled={page <= 1 || loading}
          onClick={() => onPage(Math.max(1, page - 1))}
          className="rounded-lg"
        >Précédent</Button>
        <span data-testid={`${testPrefix}pagination-current`} className="text-navy font-semibold whitespace-nowrap">
          Page {page} / {Math.max(1, totalPages)}
        </span>
        <Button
          data-testid={`${testPrefix}pagination-next`}
          size="sm" variant="outline"
          disabled={page >= totalPages || loading}
          onClick={() => onPage(page + 1)}
          className="rounded-lg"
        >Suivant</Button>
      </div>
    </div>
  );
}
